var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c("search-page", {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:lottery-assistant:activity:record:list"],
            expression: "['platform:lottery-assistant:activity:record:list']",
          },
        ],
        ref: "searchPage",
        attrs: {
          "form-data": _vm.formData,
          columns: _vm.columns,
          request: _vm.getList,
        },
        on: { searched: _vm.handleSearch },
        scopedSlots: _vm._u([
          {
            key: "page-operation",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "acea-row row-middle row-around text-center" },
                  [
                    _c("div", [
                      _c("div", [
                        _vm._v(_vm._s(_vm.statisticData.participantCount)),
                      ]),
                      _c("div", [_vm._v("参与人数")]),
                    ]),
                    _c("div", [
                      _c("div", [
                        _vm._v(_vm._s(_vm.statisticData.participationCount)),
                      ]),
                      _c("div", [_vm._v("参与次数")]),
                    ]),
                    _c("div", [
                      _c("div", [
                        _vm._v(_vm._s(_vm.statisticData.avgFrequency)),
                      ]),
                      _c("div", [_vm._v("人均频次")]),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "table-append",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    fixed: "right",
                    label: "操作",
                    align: "center",
                    "min-width": "220",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c(
                            "p",
                            [
                              _c(
                                "span",
                                { staticStyle: { "padding-right": "5px" } },
                                [_vm._v("操作")]
                              ),
                              _c("right-toolbar", {
                                attrs: { columns: _vm.columns },
                                on: { refresh: _vm.refreshList },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm.checkPermi([
                            "platform:lottery-assistant:record:setStatus",
                          ]) &&
                          !row.prizeStatus &&
                          row.prizeType != 99
                            ? [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleStatus(row)
                                      },
                                    },
                                  },
                                  [_vm._v("发放")]
                                ),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }